import { compose } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import immutableToJS from 'utils/immutableToJS';

import {
  currentServiceRequestAssetSelector,
} from 'redux/serviceRequests/selectors';

import withAssetDetailRequestOnlyFields from './withAssetDetailRequestOnlyFields';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function Container(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  Container.propTypes = {
    assetInfo: PropTypes.shape(),
  };

  Container.defaultProps = {
    assetInfo: {},
  };

  function mapStateToProps(state) {
    return {
      assetInfo: currentServiceRequestAssetSelector(state),
    };
  }

  return compose(
    connect(mapStateToProps),
    immutableToJS,
    withAssetDetailRequestOnlyFields,
  )(Container);
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/AssetsWidget/ServiceRequestAssetsContainer.js